import { render } from "./RadioOptionBoxesInput.vue?vue&type=template&id=5de4fc32&scoped=true"
import script from "./RadioOptionBoxesInput.vue?vue&type=script&lang=js"
export * from "./RadioOptionBoxesInput.vue?vue&type=script&lang=js"

import "./RadioOptionBoxesInput.vue?vue&type=style&index=0&id=5de4fc32&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de4fc32"]])

export default __exports__